import React from 'react';
import {findItem} from '../../../utils/kvp.utils';

const tone = (percent, validated) => {
    if (percent == null) return {bg: "#F1F3F7", text: "#7A849A"};
    if (validated) return {bg: "#E7F7EB", text: "#1B7A31"};
    if (percent >= 80) return {bg: "#E7F7EB", text: "#1B7A31"};
    if (percent >= 50) return {bg: "#FFF4E0", text: "#9B6B00"};
    return {bg: "#FDECEC", text: "#A4231D"};
};

const ConfidenceLabel = ({label, data, index}) => {
    const item = Array.isArray(data) ? findItem(label, data, index) : data;
    if (!item) return null;
    const percent = item?.confidencePercent ?? null;
    const {bg, text} = tone(percent, item?.confidenceValidated);

    return (
        <span
            title={item?.confidenceValidated ? "Validated" : percent !== null ? `${percent}% confidence` : "No confidence"}
            className="inline-flex items-center gap-1 px-1.5 h-[18px] text-[10px] font-semibold rounded-md flex-shrink-0"
            style={{
                backgroundColor: bg,
                color: text,
                lineHeight: 1,
            }}
        >
            <span style={{width: 4, height: 4, borderRadius: "50%", backgroundColor: text}}/>
            {percent !== null ? `${percent}%` : "—"}
        </span>
    );
};

export default ConfidenceLabel;

